/* eslint-disable comma-dangle */
$('.evalutaion__back').click((e) => {
  e.preventDefault();
  try {
    $('html, body').animate({
      scrollTop: $('.ranking__groups').offset().top
    }, 500);
  } catch (err) {
    $('html, body').animate({
      scrollTop: $('.nav').offset().top
    }, 500);
  }
});



// WEBPACK FOOTER //
// local_static/templates/guias/2018/assets/scripts/linkToTopModule.js